import { NJButton, NJText } from '@engie-group/fluid-design-system-react';
import { UMR } from '../../urbanmap/_components';
import { planStatus } from './model';
import type { Project } from './types';
import { ACCENT } from './ui';

export function ProjectList({ projects, onOpen }: { projects: Project[]; onOpen: (id: string) => void }) {
  return (
    <div style={{ padding: 32, maxWidth: 1200, margin: '0 auto', fontFamily: UMR.font }}>
      <NJText as="h1" scale="lg" style={{ margin: '0 0 4px' }}>Mes projets Plan</NJText>
      <NJText scale="md" style={{ margin: '0 0 24px', color: UMR.textSecondary }}>
        {projects.length} projets — chaque projet est une copie de travail figée d’un périmètre UrbanMap.
      </NJText>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))', gap: 16 }}>
        {projects.map((p) => {
          const statuses = p.plans.map((s) => planStatus(p, s));
          const done = statuses.filter((s) => s === 'done').length;
          const stale = statuses.filter((s) => s === 'stale').length;
          return (
            <article key={p.id} aria-label={p.name} style={{ border: `1px solid ${UMR.border}`, background: UMR.white, padding: 20, display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div>
                <NJText as="h2" scale="md" style={{ margin: 0 }}>{p.name}</NJText>
                <div style={{ fontSize: 14, color: UMR.textSecondary }}>{p.perimeterLabel}</div>
              </div>
              <dl style={{ margin: 0, display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '4px 16px', fontSize: 14 }}>
                <dt style={{ color: UMR.textSecondary }}>Copie du</dt><dd style={{ margin: 0 }}>{p.snapshotDate}</dd>
                <dt style={{ color: UMR.textSecondary }}>Propriétaire</dt><dd style={{ margin: 0 }}>{p.owner}</dd>
                <dt style={{ color: UMR.textSecondary }}>Jeux d’hypothèses</dt><dd style={{ margin: 0 }}>{p.sets.demande.length + p.sets.trace.length + p.sets.developpement.length + p.sets.phasage.length + p.sets.importance.length + p.sets.pointsDepart.length} jeux · 6 familles</dd>
                <dt style={{ color: UMR.textSecondary }}>Plans de dev</dt>
                <dd style={{ margin: 0 }}>{p.plans.length}{done ? ` · ${done} calculé${done > 1 ? 's' : ''}` : ''}{stale ? ` · ${stale} obsolète${stale > 1 ? 's' : ''}` : ''}</dd>
              </dl>
              <div style={{ fontSize: 12, color: p.umDriftCount ? 'var(--nj-core-color-orange-800, #8a3c14)' : 'var(--nj-core-color-green-800, #1b6b30)' }}>
                {p.umDriftCount ? `${p.umDriftCount} bâtiments modifiés dans UrbanMap depuis la copie` : 'À jour avec UrbanMap'}
              </div>
              <div style={{ marginTop: 'auto', borderTop: `2px solid ${ACCENT}`, paddingTop: 12 }}>
                <NJButton label="Ouvrir le projet" variant="primary" onClick={() => onOpen(p.id)} />
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}
